import '../scss/frontend.scss';
import Swiper, { Autoplay, Pagination, EffectFade } from 'swiper';

document.addEventListener('DOMContentLoaded', () => {
	const wp_block_media_text__media = document.querySelectorAll('.wp-block-media-text__media, .image-zoom');

	wp_block_media_text__media.forEach((elem) => {
		const handler = (entries) => {
			if (entries[0].isIntersecting) {
				elem.classList.add('is-visible');
			} else {
				elem.classList.remove('is-visible');
			}
		};

		const observer = new window.IntersectionObserver(handler, {
			threshold: 0.5,
		});
		observer.observe(elem);
	});

	// var swiper = new Swiper(".hero-swiper", {
	// 	modules: [Autoplay, EffectFade, Pagination],
	// 	autoplay: {
	// 		delay: 5000,
	// 		disableOnInteraction: false,
	// 	  },
	// 	  speed: 1000,
	// 	loop: true,
	// 	effect: "fade",
	//     pagination: {
	//       el: ".swiper-pagination",
	// 	  clickable: true
	//     },
	//   });

	const wrapper = document.querySelector('.site-header__wrapper');
	const header = document.querySelector('.site-header');

	const navbarObserver = (entries) => {
		if (entries[0].isIntersecting) {
			header.classList.remove('stuck');
		} else {
			header.classList.add('stuck');
		}
	};

	const observer = new window.IntersectionObserver(navbarObserver, {
		threshold: 1,
	});
	observer.observe(wrapper);

	var content_swiper = new Swiper('.swiper-content', {
		modules: [Autoplay, EffectFade, Pagination],
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		speed: 1000,
		loop: true,
		effect: 'fade',
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
	});

	var configurator_swiper_EL = document.querySelector('.swiper-configurator');

	if (configurator_swiper_EL) {
		var configurator_swiper = new Swiper('.swiper-configurator', {
			modules: [EffectFade, Pagination],
			effect: 'fade',
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			on: {
				init: function () {
					const images = configurator_swiper_EL.querySelectorAll('img');
					const pag = configurator_swiper_EL.querySelectorAll('.swiper-pagination-bullet');

					for (let index = 0; index < images.length; index++) {
						pag[index].style.backgroundColor = images[index].dataset.caption;
					}
				},
			},
		});
	}

	document.addEventListener( 'wpcf7submit', function( event ) {
		if ( '416' == event.detail.contactFormId || '297' == event.detail.contactFormId ) {
		  var url= 'https://www.caton.uk/wp-content/uploads/PDF-Technical-Download.pdf';
                  var link = document.createElement('a');
				  link.target = '_blank';
                  link.href = url;
                  link.download = url.split("/").pop();
				  link.textContent = 'If your file has not downloaded please click this link';
				  document.querySelector('.wpcf7-response-output').after(link);
                  link.dispatchEvent(new MouseEvent('click'));
		}
	  }, false );
});
